import { AllowedMarkdownElements } from './chunk-OKFAUBKL.mjs';
import { marked, Renderer } from 'marked';
import SanitizeHtml from 'sanitize-html';

var headingStyles = {
  "font-family": "Figtree, Sans-serif",
  "font-weight": "700",
  color: "#000",
  "text-align": "inherit",
  "line-height": "1.2",
  "margin-bottom": "0.8em"
};
var emailStyles = {
  heading: headingStyles,
  h1: {
    ...headingStyles,
    "font-size": "22px",
    "margin-bottom": "40px"
  },
  h2: {
    ...headingStyles,
    "font-size": "18px"
  },
  h3: {
    ...headingStyles,
    "font-size": "16px"
  },
  h4: {
    ...headingStyles,
    "font-size": "14px"
  },
  h5: {
    ...headingStyles,
    "font-size": "12px"
  },
  h6: {
    ...headingStyles,
    "font-size": "10px"
  },
  paragraph: {
    "white-space-collapse": "preserve",
    "text-wrap-mode": "wrap",
    color: "#000",
    "line-height": "1.8",
    "font-size": "16px",
    "margin-bottom": "20px",
    "font-family": "Figtree, Sans-serif",
    "font-weight": "400",
    "text-align": "left"
  },
  img: {
    "max-width": "100%",
    "margin-bottom": "0.8em",
    "margin-top": "0.8em"
  }
};
var objectToStyleString = (obj) => {
  return Object.entries(obj ?? {}).map(([key, value]) => `${key}:${value}`).join(";");
};
var EmailRenderer = () => {
  const renderer = new Renderer();
  const defaultParagraph = renderer.paragraph.bind(renderer);
  const defaultHeading = renderer.heading.bind(renderer);
  const defaultImage = renderer.image.bind(renderer);
  renderer.paragraph = (config) => {
    const style = objectToStyleString(emailStyles.paragraph);
    const paragraph = defaultParagraph(config);
    return paragraph.replace(/<p([^>]*)>/gi, `<p style="${style}"$1>`);
  };
  renderer.heading = (config) => {
    const style = objectToStyleString(
      emailStyles[`h${config.depth}`] || emailStyles.heading
    );
    const heading = defaultHeading(config);
    return heading.replace(/<h(\d)([^>])*>/gi, `<h$1 style="${style}" $2>`);
  };
  renderer.image = (config) => {
    const style = objectToStyleString(emailStyles.img);
    const image = defaultImage(config);
    return image.replace(/<img([^>])*>/gi, `<img style="${style}" src="${config.href}" alt="${config.text}" >`);
  };
  return renderer;
};
var Markdown;
((Markdown2) => {
  Markdown2.AllowedElements = AllowedMarkdownElements;
  Markdown2.useEmail = {
    renderer: EmailRenderer()
  };
  Markdown2.toHtml = (source, options = {}) => {
    const html = marked.parse(source, {
      async: false,
      ...options
    });
    return sanitizeHtml(html);
  };
  Markdown2.toHtmlAsync = async (source, options = {}) => {
    const html = await marked.parse(source, {
      async: true,
      ...options
    });
    return sanitizeHtml(html);
  };
  const sanitizeHtml = (html, options = {}) => {
    return SanitizeHtml(html, {
      allowedTags: Markdown2.AllowedElements,
      allowedAttributes: {
        a: ["href", "name", "style", "class"],
        p: ["style", "class"],
        span: ["style", "class"],
        h1: ["style", "class"],
        h2: ["style", "class"],
        h3: ["style", "class"],
        h4: ["style", "class"],
        h5: ["style", "class"],
        h6: ["style", "class"],
        img: ["src", "alt", "style", "class"],
        ...options.allowedAttributes
      },
      ...options
    });
  };
})(Markdown || (Markdown = {}));

export { Markdown, emailStyles, objectToStyleString };
